import { Component } from '@angular/core';
import { PermissionsService } from '@app/services/permissions/permissions.service';


import { OidcSecurityService } from "angular-auth-oidc-client";

@Component({
  selector: 'app-impersonate',
  standalone: false,
 
  templateUrl: './impersonate.component.html',
  styleUrl: './impersonate.component.css'
})
export class ImpersonateComponent {
  userName: string = '';

  constructor(private permissionService: PermissionsService, private oicdSecurityService: OidcSecurityService) { }
 
  impersonate() {
  this.permissionService.impersonate(this.userName).subscribe({
    next: result => {
      this.oicdSecurityService.authorize(
        undefined,
        {
          customParams: {
            impersonation_id: result.impersonationId
          }
        }
      );
    },
    error: error => {
      if (error.status === 403) {
        // Hantera Forbidden
        console.error('Du saknar behörighet att impersonera användaren.');

        // Exempel:
        // this.notificationService.error(
        //   'Åtkomst nekad',
        //   'Du saknar behörighet att impersonera denna användare.'
        // );

        return;
      }

      // Hantera övriga fel
      console.error('Ett oväntat fel inträffade.', error);
    }
  });
}
  /*impersonate() {
    this.permissionService.impersonate(this.userName).subscribe(result => {

      this.oicdSecurityService.authorize(
        undefined,
        {
          customParams: {
            impersonation_id: result.impersonationId
          }
        }
      );
    })

    };*/
  }


